import { useEffect, useState } from 'react';
import * as LucideIcons from 'lucide-react';

const API_ROOT = process.env.REACT_APP_API_URL || (window.location.port === '3000'
  ? '/api'
  : `${process.env.PUBLIC_URL || ''}/api`);

const iconMap = {
  BedDouble: LucideIcons.BedDouble,
  Bed: LucideIcons.Bed,
  Bath: LucideIcons.Bath,
  Hand: LucideIcons.Hand,
  Microscope: LucideIcons.Microscope,
  Sparkles: LucideIcons.Sparkles,
  Shirt: LucideIcons.Shirt,
  RefreshCcw: LucideIcons.RefreshCcw,
  Shield: LucideIcons.Shield,
  Package: LucideIcons.Package,
  Hospital: LucideIcons.Hospital,
  Building2: LucideIcons.Building2,
  Stethoscope: LucideIcons.Stethoscope,
  Scissors: LucideIcons.Scissors,
  FileText: LucideIcons.FileText,
  ShieldCheck: LucideIcons.ShieldCheck,
  ClipboardCheck: LucideIcons.ClipboardCheck,
  Mail: LucideIcons.Mail,
  Phone: LucideIcons.Phone,
  MapPin: LucideIcons.MapPin,
  Clock: LucideIcons.Clock,
  FileCheck2: LucideIcons.FileCheck2,
  Truck: LucideIcons.Truck,
  Search: LucideIcons.Search,
  Tag: LucideIcons.Tag,
  PackageCheck: LucideIcons.PackageCheck,
  HeartPulse: LucideIcons.HeartPulse,
  CircleDollarSign: LucideIcons.CircleDollarSign,
  BriefcaseMedical: LucideIcons.BriefcaseMedical,
  Lock: LucideIcons.Lock,
  ArrowRight: LucideIcons.ArrowRight,
  CheckCircle: LucideIcons.CheckCircle,
  Download: LucideIcons.Download,
  X: LucideIcons.X,
};

export function getApiRoot() {
  return API_ROOT;
}

export function getContentIcon(iconName, fallback = LucideIcons.FileText) {
  if (!iconName) return fallback;
  if (typeof iconName === 'function') return iconName;

  const normalized = String(iconName).trim();
  const direct = iconMap[normalized];
  if (direct) return direct;

  const titleCase = normalized.charAt(0).toUpperCase() + normalized.slice(1);
  return iconMap[titleCase] || fallback;
}

export function useCollectionData(collectionKey, fallbackItems = []) {
  const [items, setItems] = useState(fallbackItems);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_ROOT}/admin/${collectionKey}`);
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || 'Unable to load data.');
        }

        const data = Array.isArray(result.data) ? result.data : [];
        if (isMounted) {
          setItems(data.length > 0 ? data : fallbackItems);
        }
      } catch (error) {
        if (isMounted) {
          setItems(fallbackItems);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadData();
    return () => {
      isMounted = false;
    };
  }, [collectionKey, fallbackItems]);

  return { items, loading };
}
